//==================== footer and header data ===================================//
export const siteConfig = {
  name: "Modish Kreations",
  email: "info@modishkreations.com",
  youtube: "https://youtube.com/yourusername",
  instagram: "https://instagram.com/yourusername",
  twitter: "https://twitter.com/yourusername",
  phone:"+91 9773724275",
  address:"Shop 12, 12A, 14 & 15 ,Arihant Arcade,First Floor,Sector-1,Bisrakh,Greater Noida West UP-201306"
}
export const navLinks = [
  { label: "Home",       href: "/"        },
  { label: "About",      href: "/about"   }, 
  { label: "Join us",     href: "/career"  },
  { label: "Contact Us", href: "/contact" },
];

export const customMadeServices = [
  { name: "Men Tailoring", href: "/gallery/menT" },
  { name: "Women Tailoring", href: "/gallery/womenT" },
  { name: "Kids Tailoring", href: "/gallery/kidsT" },
  { name: "Corporate Tailoring", href: "/gallery/corporateT" },
];

export const shop = [
  { name: "Men Clothing",   href: "/shop/men"   },
  { name: "Women Clothing", href: "/shop/women" },
  { name: "Kids Wear",  href: "/shop/kids"  },
  { name: "Ensambles",  href: "/shop/uniforms"  },
];



/* ========================== Home page  data ============================= */
 export const MARQUEE_ITEMS = [
  "Suit ",
  "Men",
  "Women",
  "Kids",
  "Kurti",
  "Saree",
  "Casual",
  "Bridal",
];


  export const TESTIMONIALS = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop",
    text: "The bespoke experience at Modish Kreations is unparalleled. Their attention to the heritage of the fabric and the precision of the fit made my wedding attire truly special.",
    client: "Aditya Vardhan",
    role: "Business Consultant"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
    text: "Finding a tailor who understands modern silhouettes while maintaining traditional craftsmanship is rare. I've found my permanent destination for all my corporate suits.",
    client: "Vikram Malhotra",
    role: "CEO, Tech Solutions"
  },
  {
    id:3,
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
    text: "The custom is good",
    client: "Mansish singh",
    role: "Customer"
  }
];

 export const STATS = [
  ["120+", "Designs"],
  ["11+",    "Years"   ],
  ["3k",   "Clients" ],

];

// custom made serives data. //
 // lib/data.ts
export const CUSTOM_PRODUCTS = [
  { id: 1, name: "Men Tailoring",       category: "menT",       dbCat: "men",       price: 15000, image: "/saree1.png", discount: "New"     },
  { id: 2, name: "Women Tailoring",     category: "womenT",     dbCat: "women",     price: 25000, image: "/saree2.png", discount: "Luxury"  },
  { id: 3, name: "Kids Tailoring",      category: "kidsT",      dbCat: "kids",      price:  5000, image: "/saree3.png", discount: "Premium" },
  { id: 4, name: "Corporate Tailoring", category: "corporateT", dbCat: "corporate", price:  8000, image: "/saree4.png", discount: "Custom"  },
];
// prodcut data //
 export const PRODUCTS = [
  { id: 1, name: "Men's Premium Ethnic Wear", category: "women", price: 4999, oldPrice: 7999, discount: "35% OFF", rating: 5, reviews: 12, image: "/saree1.png" },
    { id: 2, name: "Women's Designer Lehengas", category: "women", price: 8500, oldPrice: 12000, discount: "30% OFF", rating: 5, reviews: 24, image: "/saree2.png" },
    { id: 3, name: "Kids' Celebration Collection", category: "women", price: 1999, oldPrice: 2999, discount: "33% OFF", rating: 4, reviews: 18, image: "/saree3.png" },
    { id: 4, name: "Bespoke Italian Pant Coat", category: "uniform", price: 15500, oldPrice: 22000, discount: "25% OFF", rating: 5, reviews: 40, image: "/saree4.png" },
    { id: 5, name: "Royal Silk Sherwani", category: "men", price: 12000, oldPrice: 18000, discount: "33% OFF", rating: 5, reviews: 15, image: "/saree1.png" },
    { id: 6, name: "Handcrafted Bridal Set", category: "women", price: 35000, oldPrice: 50000, discount: "30% OFF", rating: 5, reviews: 50, image: "/saree2.png" },
];

// FAQ section -------------- //

// *------------------------------- Contact Us -----------------------------------*//
 export interface FormData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

 export interface FormErrors {
  name?: string;
  email?: string;
  phone?: string;
  subject?: string;
  message?: string;
}



// About us section - Team //
 export const TEAM = [
  {
    id: 1,
    image: "/team1.png",
    name: "Amrit Singh",
    role: "Production Manager",
    initial: "AS",
    bio: "10 years shaping visual identities for fashion houses across Mumbai and Paris.",
  },

];

 export const VALUES = [
  {
    num: "01",
    title: "On time Delivery",
    desc: "Precision-timed logistics ensuring every bespoke garment is perfected and delivered exactly when promised, without shortcuts.",
  },
 {
  num: "02",
  title: "Uncompromising Quality",
  desc: "A deliberate selection of premium fabrics and meticulous craftsmanship, treating every single stitch as a signature.",
},
  {
    num: "03",
    title: "Satisfaction",
    desc: "A creative partnership driven by honest dialogue and expert guidance to ensure your vision meets excellence.",
  },
];


// *------------------------------- Contact Us -----------------------------------*//
 export interface FormData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

 export interface FormErrors {
  name?: string;
  email?: string;
  message?: string;
}

 export const CONTACT_INFO = [
  {
    id: 1,
    label: "Visit Us",
    lines: ["1st Floor Arihant Arden, Sector - 1", "Greater Noida, Uttar Pradesh 201318"],
    icon: "📍",
  },
  {
    id: 2,
    label: "Call Us",
    lines: ["+91  97737 24275", "Wed – Mon, 10am – 8pm","Tuesday closed"],
    icon: "📞",
  },
  {
    id: 3,
    label: "Email Us",
    lines: ["info@modishkreations.com", "We reply within 24 hours"],
    icon: "✉",
  },
];

 export const SUBJECTS = [
  "General Enquiry",
  "Men's Collection",
  "Women's Collection",
  "Kids' Collection",
  "Collaboration",
  "Press & Media",
];


// gallery page //
 export const Gallery_ITEMS = [
  { id: 1, src: "/img1.png", span: "md:col-span-2 md:row-span-2", label: "Summer Collection" },
  { id: 2, src: "/img2.png", span: "col-span-1", label: "Ethnic Gold" },
  { id: 3, src: "/img3.png", span: "col-span-1", label: "Bridal Wear" },
  { id: 4, src: "/img4.png", span: "md:col-span-2 md:row-span-1", label: "Modern Chic" },
];

// carrer page //
 export const JOBS = [
  {
    id: "01",
    role: "Senior Fashion Designer",
    department: "Design",
    type: "Full-Time",
    location: "Noida, Sector 63"
  },
  {
    id: "02",
    role: "Social Media Manager",
    department: "Marketing",
    type: "Remote / Hybrid",
    location: "Delhi NCR"
  },
  {
    id: "03",
    role: "Boutique Manager",
    department: "Operations",
    type: "Full-Time",
    location: "Noida, Sector 62"
  },
  {
    id: "04",
    role: "Embroidery Artist",
    department: "Production",
    type: "Contract",
    location: "Noida"
  }
];


// doorstep service section //
 export const doorstepServiceSteps = [
  {
    title: "Schedule a Visit",
    description: "Contact us to schedule a convenient time for our tailor to visit your home at your preferred date and time.",
  },
  {
    title: "Consultation and Measurements",
    description: "Our expert tailor will consult with you to understand your requirements and take accurate measurements.",
  },
  {
    title: "Fabric Selection",
    description: "If you have your own fabric, our tailor will inspect it to ensure it's suitable for your desired design.",
  },
  {
    title: "Stitching and Fittings",
    description: "Once the fabric and measurements are finalized, our team gets to work on creating your custom garment.",
  },
  {
    title: "Final Delivery",
    description: "After the fitting and any adjustments, your finished garment is delivered to your doorstep.",
  },
];